import React from "react";
import PageBanner from "../../components/common/PageBanner";
import BgImage from "../../Assets/Images/SportsAcademy/sports-academy-banner.webp";
import GamesSection from "../../components/User/SportsAcademy/GamesSection";
import BenfitsOfStrikeAndSports from "../../components/User/SportsAcademy/BenfitsOfStrikeAndSports";
import CommentsSection from "../../components/User/SportsAcademy/CommentsSection";
import { useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";

const SportsAcademy = () => {
  const location = useLocation();
  const activeTab = location.state?.activeTab || null;
  const [bannerData, setBannerData] = useState({});
  const [loading, setLoading] = useState(false);

  const getBannerData = () => {
    setLoading(true);
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/page-banner/get-banner/sports-academy`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log(JSON.stringify(response.data));
        setBannerData(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  useEffect(() => {
    getBannerData();
  }, []);

  return (
    <div>
      {loading ? (
        <BannerSkeleton />
      ) : (
        <PageBanner
          title={bannerData.title}
          subtitle={bannerData.subtitle}
          background={bannerData.bgImage}
        />
      )}
      <GamesSection activeTab={activeTab} />

      <BenfitsOfStrikeAndSports />
      <CommentsSection />
    </div>
  );
};

export default SportsAcademy;

const BannerSkeleton = () => {
  return (
    <div className="relative w-full h-36 sm:h-52 md:h-60 lg:h-80 px-4 md:px-8 lg:px-12 animate-pulse">
      <div className="absolute inset-0 bg-gray-300/50"></div>

      <div className="relative z-10 flex flex-col justify-center h-full">
        <div className="h-8 w-40 bg-gray-400/60 rounded-md mb-4"></div>
        <div className="h-4 w-64 bg-gray-400/50 rounded-md"></div>
      </div>
    </div>
  );
};
